import { templateApi } from './consts';
import { tokenHeader, getUserToken } from "./user-service";

const apiEndPoint = templateApi;

export var getTemplates = () => {
    return fetch(apiEndPoint, {
        headers: {
            [tokenHeader]: getUserToken()
        }
    })
        .then(res => res.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}

export var getTemplatesById = (id) => {
    return fetch(apiEndPoint + '/' + id, {
        headers: {
            [tokenHeader]: getUserToken()
        }
    })
        .then(res => res.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}

export var dateFormat = (dateStr) => {
    let date = new Date(dateStr);
    return date.toLocaleDateString().replaceAll("/", "-");;
} 